import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

import "./ExpandCarDetail.css";

class ExpandCarDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }
  useStyles = () =>
    makeStyles(theme => ({
      root: {
        width: "100%"
      },
      heading: {
        fontFamily: "ToyotaRegular",
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0
      },
      secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary
      }
    }));

  handleChange = panel => (event, isExpanded) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };

  render() {
    const classes = this.useStyles();

    return (
      <div className={"ExpansionRoot"}>
        <ExpansionPanel
          expanded={this.state.expanded === "panel1"}
          onChange={this.handleChange("panel1")}
          className="ExpansionPanel"
        >
          <ExpansionPanelSummary
            expandIcon={
              this.state.expanded === "panel1" ? (
                <RemoveIcon className="AddIcon" />
              ) : (
                <AddIcon className="AddIcon" />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="ExpandHeading"
          >
            ESPECIFICACIONES TECNICAS
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="ExpansionPanelDetails">
            <Typography>
              <div className="ExpandCarDescription">
                <div className="CarTextSmall">
                  {" "}
                  <b>VERSIÓN:</b>
                  {this.props.version}
                </div>
                <div className="hr"></div>
                <div className="CarTextSmall">
                  {" "}
                  <b>MOTOR: </b>
                  {this.props.motor}
                </div>
                <div className="hr"></div>
                <div>
                  {" "}
                  <b>TIPO: </b>
                  {this.props.tipo}
                </div>
                <div className="hr"></div>

                <div>
                  {" "}
                  <b>COLOR: </b>
                  {this.props.color}
                </div>
                <div className="hr"></div>
                <div>
                  {" "}
                  <b>MODELO: </b>
                  {this.props.year}
                </div>
                <div className="hr"></div>
                <div>
                  {" "}
                  <b>TRANSMISION:</b> {this.props.gear}
                </div>
              </div>
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel
          expanded={this.state.expanded === "panel2"}
          onChange={this.handleChange("panel2")}
          className="ExpansionPanel"
        >
          <ExpansionPanelSummary
            expandIcon={
              this.state.expanded === "panel2" ? (
                <RemoveIcon className="AddIcon" />
              ) : (
                <AddIcon className="AddIcon" />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="ExpandHeading"
          >
            CARACTERISTICAS
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="ExpansionPanelDetails">
            <Typography>
              <div>
                <div className="ExpandTextDetailTitle">
                  {this.props.titulo1}
                </div>
                <div className="ExpandTextDetail">{this.props.texto1}</div>
                <div className="ExpandTextDetailTitle">
                  {this.props.titulo2}
                </div>
                <div className="ExpandTextDetail">{this.props.texto2}</div>
                <div className="ExpandTextDetailTitle">
                  {this.props.titulo3}
                </div>
                <div className="ExpandTextDetail">{this.props.texto3}</div>
              </div>
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

export default ExpandCarDetail;
